import axios from 'axios';

const PORTFOLIO_BUILDER_URL =
  process.env.REACT_APP_PORTFOLIO_BUILDER_URL || 'http://localhost:8080/api/v1/portfolio';

const portfolioClient = axios.create({
  baseURL: PORTFOLIO_BUILDER_URL,
  timeout: 120000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const getPortfolioBuilderUrl = () => PORTFOLIO_BUILDER_URL;

export async function fetchLlmStatus() {
  const { data } = await portfolioClient.get('/llm/status');
  return data;
}

export async function switchLlmProvider(payload) {
  const { data } = await portfolioClient.post('/llm/switch', payload);
  return data;
}

export async function buildPortfolio(request, includeAi = false) {
  const path = includeAi ? '/portfolio/build-with-ai' : '/portfolio/build';
  const { data } = await portfolioClient.post(path, request);
  return data;
}

export async function fetchProfiles() {
  const { data } = await portfolioClient.get('/portfolio/profiles');
  return data;
}

export async function fetchHealth() {
  const { data } = await portfolioClient.get('/health');
  return data;
}

export default portfolioClient;
